import API_BASE_URL from "../utils/config";
import request from "../utils/request";

export async function postExam(data) {
  const url = `${API_BASE_URL}/exams`;
  return request({
    url,
    method: "post",
    data,
  });
}

export async function fetchAll(data) {
  const url = `${API_BASE_URL}/exams`;
  return request({
    url,
    method: "get",
    data,
  });
}

export async function fetchExam(id) {
  const url = `${API_BASE_URL}/exams/${id}`;
  return request({
    url,
    method: "get",
  });
}

export async function postEdit(data) {
  const { id, name, description, month, year, active, examGroupId } = data;
  const url = `${API_BASE_URL}/exams/${id}`;
  return request({
    url,
    method: "put",
    data: { description, name, month, year, active, examGroupId },
  });
}

export async function examDelete(id) {
  const url = `${API_BASE_URL}/exams/${id}`;
  return request({
    url,
    method: "delete",
  });
}
